import * as React from 'react'
import type { SVGProps } from 'react'
const MegaPhoneSimple = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.8547 6.77031L4.1 2.55156C3.91383 2.49727 3.71758 2.48703 3.52678 2.52166C3.33597 2.55629 3.15584 2.63484 3.00062 2.7511C2.84541 2.86735 2.71938 3.01813 2.63249 3.1915C2.5456 3.36487 2.50024 3.55608 2.5 3.75V15C2.5 15.3315 2.6317 15.6495 2.86612 15.8839C3.10054 16.1183 3.41848 16.25 3.75 16.25C3.86953 16.25 3.98845 16.2329 4.10313 16.1992L10.625 14.1977V15C10.625 15.3315 10.7567 15.6495 10.9911 15.8839C11.2255 16.1183 11.5435 16.25 11.875 16.25H14.375C14.7065 16.25 15.0245 16.1183 15.2589 15.8839C15.4933 15.6495 15.625 15.3315 15.625 15V12.6641L17.8547 11.9805C18.1127 11.9029 18.3391 11.7445 18.5003 11.5286C18.6615 11.3127 18.749 11.0507 18.75 10.7813V7.96875C18.7488 7.69944 18.6612 7.43761 18.5 7.22185C18.3388 7.0061 18.1126 6.84781 17.8547 6.77031ZM10.625 12.8906L3.75 15V3.75L10.625 5.85938V12.8906ZM14.375 15H11.875V13.8141L14.375 13.0469V15ZM17.5 10.7813H17.4914L11.875 12.5063V6.24375L17.4914 7.9625H17.5V10.775V10.7813Z'
      fill='white'
    />
  </svg>
)
export default MegaPhoneSimple
